import { createBrowserHistory as createHistory, History } from 'history' 
import config from 'shared/config';
import thunk from 'redux-thunk';
import { applyMiddleware, createStore } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import reducers from './reducers';

export const setHistoryConfig = () => {
	const setConfig = {};
	if (process.env.NODE_ENV === 'production') {
		// Remove the protocol and hostname ('http://something.com' part) from the eSTORIS URL
		// Another way to do this is:
		// setConfig.basename = config.ESTORIS_BASE_PATH.replace(/^https?:\/\/[^/]*/, '');
		setConfig.basename = new URL(config.ESTORIS_BASE_PATH).pathname;
	}
	return setConfig;
};

export const history = createHistory(setHistoryConfig());

export const buildStore = () => {
	// prepare store for redux dev tools
	// reference: https://github.com/zalmoxisus/redux-devtools-extension#usage
	/* eslint no-underscore-dangle: ["error", { "allow": ["__REDUX_DEVTOOLS_EXTENSION__"] }] */
	// const preloadedState =
	// 	process.env.NODE_ENV === 'development'
	// 		? window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
	// 		: undefined;

	 const routerHistory = routerMiddleware(history);

	// return createStore(reducers, preloadedState, applyMiddleware(thunk, routerHistory));

	
	return createStore(reducers, applyMiddleware(thunk, routerHistory))
};
